import React, { useEffect, useCallback } from 'react'
import { Row, Col, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { useKaraoke } from 'hooks/karaoke'

import { UploadingView } from 'views/Uploading'
import { useKaraokeUpload } from 'hooks/karaokeUpload'
import { get } from 'lodash'
import { useLyricProcessor } from 'hooks/lyric'
import { useTimelineEvents } from 'hooks/TimelineEvents'
import { SMALL_CANVAS_PROPS } from 'constans/konva'

const ButtonContainer = ({ children }) => (
  <Row justify="end" align="middle" className="stretched">
    <Col>{children}</Col>
  </Row>
)

const NewKaraoke = (props) => (
  <Button type="primary" {...props}>
    Create Another
    <ReloadOutlined />
  </Button>
)

export const UploadingPhase = (props) => {
  const { audio, instructions, lyrics, resetBuild, metadata } = useKaraoke()
  const { resetLyricProcessor } = useLyricProcessor()
  const { resetTimelineEvents } = useTimelineEvents()
  const { startUpload, progress, finished } = useKaraokeUpload()

  const goBackToStart = useCallback(() => {
    resetBuild()
    resetTimelineEvents()
    resetLyricProcessor()
  }, [])

  useEffect(() => {
    startUpload({ audio, instructions, lyrics, metadata })
  }, [])

  return (
    <>
      <Row className="footer" align="middle" justify="center">
        <Col>
          <UploadingView progress={progress} />
        </Col>
      </Row>
      <Row className="footer" align="middle" justify="center">
        <Col>
          <ButtonContainer>
            <NewKaraoke onClick={goBackToStart} disabled={!finished} />
          </ButtonContainer>
        </Col>
      </Row>
    </>
  )
}
